// initial state
const state = {
  show: false,
  seriesCode: null
};

// getters
const getters = {};

// actions
const actions = {
  toggleTestDrive(context,seriesCode) {
    context.commit('toggleTestDrive',seriesCode);
  }
};

// mutations
const mutations = {
  toggleTestDrive(state,seriesCode) {
    state.show = !state.show;
    state.seriesCode = seriesCode !== undefined ? seriesCode : null;
    window.document.getElementsByTagName('html').item(0).className = state.show ? 'noscroll' : '';
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/testDrive.js